import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../context";
import { TrailAccount } from "../../../components/account/TrailAccount";
import TopHeader from "./TopHeader/TopHeader";
import AppMenus from "./Menus/AppMenus";
import NewAppMenus from "./Menus/NewAppMenus";
import LayoutContainer from "./LayoutContainer";
import * as apiClient from "../../../common/apiClient";
import * as apiMethod from "../../../common/apiMethod";
import * as appModule from "../../../common/appModule";
import Sidebar from "../DefaultLayout/Sidebar";
import SidebarContextProvider from "./Sidebar/Context";

export const DefaultLayout = (props) => {
  const authContext = useContext(AuthContext);
  const [isTrailAccount, setTrailAccount] = useState(false);
  const [iscollapseLeftMenu, setcollapseLeftMenu] = useState(false);
  const [isappModuleLoading, setAppModuleLoading] = useState(false);
  const [appModules, setappModules] = useState([]);

  useEffect(() => {
    if (
      localStorage.isLoggedIn === undefined ||
      localStorage.isLoggedIn === undefined ||
      !localStorage.isLoggedIn
    ) {
      props.history.push("/login");
    }
    //const subscriptionTypeName=localStorage.getItem("SubscriptionTypeName");
    //setTrailAccount((subscriptionTypeName!=null && subscriptionTypeName!=undefined && subscriptionTypeName.toString().trim().toUpperCase()==="TRIAL"))
  }, []);

  useEffect(() => {
    getAppModule();
  }, []);

  const closeTrail = () => {
    setTrailAccount(false);
  };
  const collapseLeftMenu = () => {
    setcollapseLeftMenu(!iscollapseLeftMenu);
  };

  const getAppModule = async () => {
    let formBody = {};
    setAppModuleLoading(true);
    await apiClient
      .post(
        `${apiClient.baseUrl}${appModule.tenancyModule}${apiMethod.getUserModules}`,
        formBody
      )
      .then((response) => {
        setappModules(JSON.parse(response.ResultSet));
        setAppModuleLoading(false);
      })
      .catch((err) => {
        setAppModuleLoading(false);
      });
  };

  return (
    <SidebarContextProvider>
      <div className="main-container">
        {isTrailAccount === true ? <TrailAccount close={closeTrail} /> : null}
        {/* <TopHeader isTrailAccount={isTrailAccount} /> */}
        <div className="wrapper-allignment-all">
          {/* <AppMenus collapseLeftMenu={collapseLeftMenu} appModules={appModules} loading={isappModuleLoading} {...props}/> */}
          <Sidebar appModules={appModules} />

          {/* <NewAppMenus collapseLeftMenu={collapseLeftMenu} appModules={appModules} loading={isappModuleLoading} {...props}/> */}
          <LayoutContainer
            iscollapseLeftMenu={iscollapseLeftMenu}
            appModules={appModules}
            loading={isappModuleLoading}
            {...props}
          />
        </div>
      </div>
    </SidebarContextProvider>
  );
};
export default DefaultLayout;
